import { CATS, MOTIF } from '../data/catalog.js';
import { useStore } from '../lib/store.jsx';
import { useI18n } from '../lib/i18n.jsx';
import ProductCard from '../components/ProductCard.jsx';
import Breadcrumb from '../components/Breadcrumb.jsx';

export default function Category({ cat, nav }) {
  const { products } = useStore();
  const { t } = useI18n();
  const isAll = !cat || cat === 'all';
  const list = isAll ? products : products.filter((p) => p.cat === cat);
  const c = CATS[cat];

  return (
    <>
      <Breadcrumb nav={nav} items={[
        { label: t('bc.home'), path: '/' },
        { label: isAll || !c ? t('cat.all') : c.t },
      ]} />
      {isAll || !c ? (
        <section className="cathero">
          <div className="bg" style={{ background: 'linear-gradient(120deg,#2b3a52,#5d6553 55%,#7a4a34)' }} />
          <div className="wrap">
            <div className="n">Shop All · barebones.co.th</div>
            <h1>Everything</h1>
            <p>{t('cat.allSub')}</p>
          </div>
        </section>
      ) : (
        <section className="cathero">
          <div className="bg" style={{ background: `linear-gradient(120deg,${c.g1},${c.g2})` }} />
          <div className="motifbig" dangerouslySetInnerHTML={{ __html: MOTIF[c.motif].replace('class="motif"', '') }} />
          <div className="wrap">
            <div className="n">{c.n} / Collection · {t('cat.items', list.length)}</div>
            <h1>{c.t}</h1>
            <p>{t(`cat.${cat}.mood`)}</p>
          </div>
        </section>
      )}
      <section className="blk">
        <div className="wrap">
          <div className="filters">
            <button className={`chip${isAll ? ' on' : ''}`} onClick={() => nav('/c/all')}>{t('cat.filterAll')}</button>
            {Object.entries(CATS).map(([k, cc]) => (
              <button key={k} className={`chip${cat === k ? ' on' : ''}`} onClick={() => nav(`/c/${k}`)}>{cc.t}</button>
            ))}
          </div>
          <div className="grid">
            {list.map((p) => <ProductCard key={p.id} product={p} nav={nav} />)}
          </div>
        </div>
      </section>
    </>
  );
}
